import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.compact}px;
`

export const ButtonContainer = styled.div<{ disabled: boolean }>`
  align-items: center;
  border-color: ${props => props.theme.colors.gray};
  border-radius: 4px;
  border-style: dashed;
  border-width: 1px;
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.compact}px;
  justify-content: center;
  padding: ${props => props.theme.spacing.comfortable}px ${props => props.theme.spacing.cozy}px;

  * {
    cursor: inherit;
  }

  label {
    ${props =>
      props.disabled &&
      `color: ${props.theme.palette.grayscale60};
    `}
    user-select: none;
  }

  svg {
    ${props =>
      props.disabled &&
      `fill: ${props.theme.palette.grayscale60};
    `}
  }
`

export const FirstRow = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  gap: ${props => props.theme.spacing.cozy}px;
  justify-content: center;
`

export const WarningContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
`
